import { Phone, MessageCircle, Sparkles } from "lucide-react";
import { useConsultation } from "@/context/ConsultationContext";
import { useLanguage } from "@/i18n/LanguageContext";
import { PHONE_LINK, WA_LINK } from "@/data/content";
import { track } from "@/lib/api";

export const MobileActionBar = () => {
  const { t } = useLanguage();
  const { setOpen } = useConsultation();
  return (
    <div
      data-testid="mobile-action-bar"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-white/10 bg-charcoal/95 backdrop-blur-xl md:hidden"
    >
      <a
        href={PHONE_LINK}
        data-testid="mobile-call-button"
        onClick={() => track("call_click", { source: "action_bar" })}
        className="flex flex-col items-center gap-1 py-3 text-[11px] font-bold text-offwhite"
      >
        <Phone className="h-5 w-5 text-gold" />
        {t("cta.call")}
      </a>
      <a
        href={WA_LINK()}
        target="_blank"
        rel="noreferrer"
        data-testid="mobile-whatsapp-button"
        onClick={() => track("whatsapp_click", { source: "action_bar" })}
        className="flex flex-col items-center gap-1 py-3 text-[11px] font-bold text-offwhite"
      >
        <MessageCircle className="h-5 w-5 text-gold" />
        WhatsApp
      </a>
      <button
        type="button"
        data-testid="mobile-consult-button"
        onClick={() => { track("consult_cta_click", { source: "action_bar" }); setOpen(true); }}
        className="flex flex-col items-center gap-1 bg-gold py-3 text-[11px] font-bold text-charcoal"
      >
        <Sparkles className="h-5 w-5" />
        {t("nav.estimate") === "Estimate" ? "Consult" : t("cta.consult")}
      </button>
    </div>
  );
};
